import { TFunction } from 'i18next';
import * as yup from 'yup';
import { SelectOption } from 'components/Forms';
import { AssignmentFeedback } from 'domains/assignments/types';
import { fileUploaderValidationSchema } from '@expressable/syntax-ds';

type AssignmentFeedbackForm = AssignmentFeedback;

export const getLocalizedSchema = (t: TFunction): yup.ObjectSchema<AssignmentFeedbackForm> =>
  yup
    .object({
      activitySuccess: yup
        .string()
        .required(t('form.validation.fieldIsRequired'))
        .transform(v => getDisplayLabel(v, activitySuccessOptions)),
      // @note(juan): we transform the value from index back to label string since we need to send to the backend the final readable string in english
      difficulty: yup
        .string()
        .required(t('form.validation.fieldIsRequired'))
        .transform(v => getDisplayLabel(v, difficultyOptions)),
      wouldRepeat: yup
        .string()
        .required(t('form.validation.fieldIsRequired'))
        .transform(v => getDisplayLabel(v, wouldRepeatOptions)),
      feedback: yup.string(),
      files: fileUploaderValidationSchema,
    })
    .required();

export type FormData = yup.InferType<ReturnType<typeof getLocalizedSchema>>;

// @note(juan): We don't use i18next translation here since we need to save the actual display strings and not an internal identifier
const activitySuccessOptions: SelectOption[] = [
  'Successful; it was fairly easy to do',
  'Somewhat successful; some parts were challenging',
  'Not successful; it was hard to complete',
].map((value, index) => ({ label: value, value: `${index}` }));
const difficultyOptions: SelectOption[] = ['Confident', 'Unsure or confused', 'Frustrated'].map((value, index) => ({
  label: value,
  value: `${index}`,
}));
const wouldRepeatOptions: SelectOption[] = ['Yes', 'No'].map((value, index) => ({ label: value, value: `${index}` }));

const getDisplayLabel = (value: string, options: SelectOption[]) => options.find(o => o.value === value)?.label;

export const ASSIGNMENT_FEEDBACK_FORM_OPTIONS = {
  activitySuccessOptions,
  difficultyOptions,
  wouldRepeatOptions,
};
